import { amountWithoutDecimalPlaces } from "@docsndata/stripe-cloud-functions-api";
import { accessory } from "./Accessory";
export const cannedAccessories = [
    accessory("hd.carnauba.wax.coating.50.percent.off", "50% Off HD Carnauba Wax Coating (Lasts 6 Months, Gloss Finish!)", amountWithoutDecimalPlaces(1999)),
    accessory("alloy.wheel.sealant.x4.wheels", "Alloy Wheel Sealant x4 wheels (Glossy Finish, Lasts 3 Months)", amountWithoutDecimalPlaces(3999)),
    accessory("carpet.stripes", "Carpet Stripes", amountWithoutDecimalPlaces(499)),
    accessory("deep.clean.1.seat.+.mat", "Deep Clean 1 Seat + Mat", amountWithoutDecimalPlaces(1999)),
    accessory("deep.clean.2.seats.+.mat2", "Deep Clean 2 Seats + Mats", amountWithoutDecimalPlaces(3998)),
    accessory("deep.clean.4.seats", "Deep Clean 4 Seats", amountWithoutDecimalPlaces(3999)),
    accessory("engine.bay.detail", "Engine Bay Detail", amountWithoutDecimalPlaces(999)),
    accessory("hydrophobic.body.wax", "Hydrophobic Body Wax (Lasts 2 Weeks)", amountWithoutDecimalPlaces(999)),
    accessory("london.congestion.zone.charge", "London Congestion Zone Charge (If You Live Inside The Zone)", amountWithoutDecimalPlaces(1500)),
    accessory("pet.hair.removal", "Pet Hair Removal (We Will Extract At Least 95% Of Hair)", amountWithoutDecimalPlaces(1999)),
    accessory("sanitization", "Sanitization - Kills 99.98% Of Bacteria On All Surfaces", amountWithoutDecimalPlaces(1999)),
    accessory("screenwash.refill.+.oil/fluids.check", "Screenwash Refill + Oil/Fluids Check (Stay Winter + MOT Ready!)", amountWithoutDecimalPlaces(500)),
    accessory("shampoo.headlining", "Shampoo Headlining", amountWithoutDecimalPlaces(1999)),
    accessory("soft.top.reproofing", "Soft Top Reproofing (Remove Mould And Restore Your Roof To Brand New!)", amountWithoutDecimalPlaces(4999)),
    accessory("tree.sap.excessive.bugs.bird.dropping.removal", "Tree Sap, Excessive Bugs + Bird Dropping's Removal", amountWithoutDecimalPlaces(999)),
];
export function applicableAccessories(serviceId, servicesAndAccessories, accessories) {
    if (serviceId === null) {
        return [];
    }
    const service = servicesAndAccessories.find(s => s.id === serviceId);
    if (service === undefined) {
        return [];
    }
    return (service.accessories ?? []).map(a => accessories.find(aa => aa.label === a.accessory.name)).filter(aa => aa !== undefined);
}
